import { type ValueOf } from '@/lib/utils/type'

export type SelectFilterOptionValue = ValueOf<typeof SELECT_FILTER_OPTION_VALUE_MAP>
export const SELECT_FILTER_OPTION_VALUE_MAP = {
  or: 'or',
  and: 'and',
} as const

export const SEARCH_FILTER_OPTION_ITEMS = [
  { label: 'OR', value: SELECT_FILTER_OPTION_VALUE_MAP.or },
  { label: 'AND', value: SELECT_FILTER_OPTION_VALUE_MAP.and },
]
